import { render, staticRenderFns } from "./score.shop.vue?vue&type=template&id=2da1eaf9&scoped=true"
import script from "./score.shop.vue?vue&type=script&lang=js"
export * from "./score.shop.vue?vue&type=script&lang=js"
import style0 from "./score.shop.vue?vue&type=style&index=0&id=2da1eaf9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da1eaf9",
  null
  
)

export default component.exports